// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

export const teamGrid = () => {
  var teamMembers = '';

  $('.team-grid .wp-block-column:not(:empty)').each(function (i) {
    $(this).attr('id', i);
    var teamMember =
      '<div id="team-info-' +
      i +
      '" class="swiper-slide">' +
      $(this).html() +
      '</div>';
    teamMembers = teamMembers + teamMember;
  });

  $('body').append(
    '<div id="team-swiper-lightbox"><a href="#" class="lightbox-closer">Close</a><div class="swiper team-swiper"><div class="swiper-wrapper">' +
      teamMembers +
      '</div><div class="swiper-button-prev"></div><div class="swiper-button-next"></div></div></div>'
  );

  const teamSwiper = new Swiper('.team-swiper', {
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    spaceBetween: 0,
    centeredSlides: false,
    preloadImages: true,
    effect: 'fade',
    // fadeEffect: {
    //   crossFade: true,
    // },
  });

  $('.team-grid .wp-block-column:not(:empty)').click(function (e) {
    var slideTarget = $(this).attr('id');
    $('#team-swiper-lightbox').addClass('swiper-open');
    teamSwiper.slideTo(slideTarget);
  });

  $(document).mouseup(function (e) {
    var container = $('.team-swiper');

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('#team-swiper-lightbox').removeClass('swiper-open');
    }
  });

  $('.lightbox-closer').click(function () {
    $('#team-swiper-lightbox').removeClass('swiper-open');
    return false;
  });
};
